import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { ButtonStyleDefaultsModel } from './button-style-defaults.model';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';

export class ButtonStyleFieldModel implements FormFieldModel {
    property: string;
    defaults: ButtonStyleDefaultsModel;
    label?: string;
    showStyleState?: boolean;
    styleType?: StyleTypesApiEnum;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    description?: string;
    defaultStyleStateOptions: DropdownOptionModel[];
    allowExpertMode?: boolean = true;

    constructor(
        property: string,
        defaults: ButtonStyleDefaultsModel,
        label?: string,
        showStyleState?: boolean,
        styleType?: StyleTypesApiEnum,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        description?: string,
        defaultStyleStateOptions?: DropdownOptionModel[]
    ) {
        this.property = property;
        this.defaults = defaults;
        this.label = label;
        this.showStyleState = showStyleState;
        this.styleType = styleType;
        this.fieldComponent = fieldComponent;
        this.description = description;
        this.defaultStyleStateOptions = defaultStyleStateOptions;
    }
}
